import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class MerchCollectionResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/events/:event_id/merch_collections' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}
